"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  t = require("./defineProperty-b53f90b9.js"),
  r = require("react"),
  n = require("prop-types"),
  a = require("./taggedTemplateLiteral-97b463ad.js"),
  i = require("styled-components"),
  l = require("polished/lib/helpers/rem"),
  o = require("./typography-fb2881fe.js");
function s(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var d,
  c,
  p,
  u,
  f,
  m,
  y = s(r),
  g = s(n),
  h = s(i),
  b = s(l),
  T = h["default"].dl(d || (d = a._taggedTemplateLiteral(["\n  margin: 0 0 0 ", ";\n  padding: 0 0 0 ", ";\n"])), b["default"](24), b["default"](8)),
  O = h["default"].span(c || (c = a._taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: ", ";\n"])), b["default"](16)),
  j = h["default"].dt(p || (p = a._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      r = e.themeType,
      n = e.disableBullet;
    return i.css(u || (u = a._taggedTemplateLiteral(["\n    display: inline;\n    margin-right: ", ";\n    float: left;\n    list-style-type: disc;\n    font-weight: 400;\n    ", "\n  "])), b["default"](4), !n && "\n      &::before {\n        content: '';\n        display: inline-block;\n        height: ".concat(b["default"](6), ";\n        width: ").concat(b["default"](6), ";\n        margin-right: ").concat(b["default"](8), ";\n        margin-bottom: ").concat(b["default"](3), ";\n        border-radius: 50%;\n        background-color: ").concat("lightTheme" === r ? t.colors.text.lightTheme["default"] : t.colors.text.darkTheme["default"], "; /** nmx-pcg and darkTheme will inherit the same styles */\n      }\n    "));
  }),
  P = h["default"].dd(f || (f = a._taggedTemplateLiteral(["\n  display: inline;\n  margin: 0;\n"]))),
  w = h["default"](o.TypographyComponent)(m || (m = a._taggedTemplateLiteral(["\n  display: inline;\n"])));
function D(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function q(e) {
  for (var r = 1; r < arguments.length; r++) {
    var n = null != arguments[r] ? arguments[r] : {};
    r % 2 ? D(Object(n), !0).forEach(function (r) {
      t._defineProperty(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var v = function v(t) {
  var n = t.className,
    a = t.descriptionListData,
    i = t.disableBullet,
    l = t.themeType;
  return r.useEffect(function () {
    a && 0 !== a.length || console.error("Missing description list data. At least one entry is required.");
  }, []), !a || a.length < 1 ? null : y["default"].createElement(T, {
    className: n
  }, " ", a && a.map(function (t, r) {
    var n = t.descriptionDetailsAttributes ? t.descriptionDetailsAttributes.reduce(function (e, t) {
      return q(q({}, e), t);
    }, {}) : {};
    return Object.prototype.hasOwnProperty.call(t, "descriptionTerm") && Object.prototype.hasOwnProperty.call(t, "descriptionDetails") && y["default"].createElement(O, {
      key: "".concat(t.descriptionTerm, "-").concat(r + 1)
    }, y["default"].createElement(j, {
      disableBullet: i,
      themeType: l
    }, y["default"].createElement(w, {
      themeType: l,
      weight: 400
    }, t.descriptionTerm)), y["default"].createElement(P, e._extends({
      itemScope: Object.prototype.hasOwnProperty.call(n, "itemType")
    }, n), y["default"].createElement(w, {
      themeType: l
    }, t.descriptionDetails)));
  }));
};
v.propTypes = {
  className: g["default"].string,
  descriptionListData: g["default"].arrayOf(g["default"].shape({
    descriptionTerm: g["default"].any.isRequired,
    descriptionDetails: g["default"].any.isRequired,
    descriptionDetailsAttributes: g["default"].arrayOf(g["default"].object)
  })).isRequired,
  disableBullet: g["default"].bool,
  themeType: g["default"].oneOf(["lightTheme", "darkTheme"])
}, v.defaultProps = {
  themeType: "lightTheme"
}, exports.DescriptionListComponent = v;